import React from 'react';
import Header from './Header';
import Background from './Background';
import Projects from './Projects';
import Contact from './Contact';
import { FaLinkedin, FaFilePdf } from 'react-icons/fa';
import './App.css';

const Home = () => {
  return (
    <div className="home-container">
      <div className="text-box">
        <h1 className="title-name">Danny Garvanski</h1>
        <h3 className="title-profession">Software Developer / Data Analyst</h3>
        <div className="button-container">
          <a href="https://www.linkedin.com/in/danny-garvanski-32999811b/" target="_blank" rel="noopener noreferrer" className="home-button linkedin-button fade-in">
            <FaLinkedin style={{ marginRight: '8px' }} /> LinkedIn
          </a>
          <a href="/Resume - Danny Garvanski.pdf" target="_blank" rel="noopener noreferrer" className="home-button pdf-button fade-in">
            <FaFilePdf style={{ marginRight: '8px' }} />  Resume
          </a>
        </div>
      </div>
      <div className="gif-container">
        <img src="/coding.gif" alt="Coding GIF" className="gif-image" />
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <video className="background-video" autoPlay loop muted playsInline>
        <source src="/background-video-1.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <Header />
      <main>
        <section id="home"><Home /></section>
        <section id="background"><Background /></section>
        <section id="projects"><Projects /></section>
        <section id="contact"><Contact /></section>
      </main>
    </div>
  );
}

export default App;